/**
 * @generated
 * This file was automatically generated and should not be manually edited.
 *
 * Auto-generated enum for: board_tasks.priority
 *
 * To regenerate: npm run db:codegen
 * Any manual changes will be overwritten on next generation.
 */

/* eslint-disable */
// @ts-nocheck

/**
 * BoardTaskPriority enum representing allowed values for board_tasks.priority
 */
export enum BoardTaskPriority {
  /** Low */
  LOW = 'low',
  /** Medium */
  MEDIUM = 'medium',
  /** High */
  HIGH = 'high',
  /** Urgent */
  URGENT = 'urgent',
}
